import type { PropsWithChildren } from 'react';

import { PageContent } from '../../page-blocks/page/page-content';
import { PageRoot, PageRootContent } from '../../page-blocks/page/page-root';

export type PagePlainProps = PropsWithChildren<{
  /**
   * The page title should only remain empty if the title is set somewhere else on the page.
   */
  title?: string;
}>;

/** @experimental In active development. Avoid using until further notice. */
export const PagePlain = ({ children, title }: PagePlainProps) => {
  if (!title) {
    return (
      <PageRootContent>
        <PageContent>{children}</PageContent>
      </PageRootContent>
    );
  }

  return (
    <PageRoot title={title}>
      <PageContent>{children}</PageContent>
    </PageRoot>
  );
};
